<template lang="html">
    <div class="question text-start mb-3">
        <div class="mb-2"><strong>{{ question.questionText }}</strong></div>
        <div v-for="answer in answers" :key="answer.id">
            <input :id="answerCheckId(answer.id)" type="radio" :name="answerCheckName(answer.id)" class="css-checkbox" v-model="answerSelected" :value="answer.id"/>
            <label :for="answerCheckId(answer.id)" class="css-label lrg klaus2 ms-2">{{ answer.choiceText }}</label>
        </div>
    </div>
</template>

<script>
export default {
    props: ['question'],

    data() {
        return {
            answerSelected : null,
        }
    },

    computed: {
        answers() {
            return this.question.choices;
        }
    },

    watch: {
        answerSelected() {
            this.$emit('answerselected', { questionId : this.question.id, answerId : this.answerSelected })
        }
    },

    methods: {
        answerCheckId(answerId) {
            return 'question' + this.question.id + 'Choice' + answerId;
        },
        answerCheckName(answerId) {
            return 'answer_' + this.question.id;
        }
    },

    mounted() {
        console.log(this.question);
    }
}
</script>

<style lang="css" scoped>
</style>
